module.exports = __webpack_public_path__ + "d6f297f9f6e265e81a2aca1db27583e0.jpg";